// eslint-disable-next-line import/prefer-default-export
export enum StatusMessageTypeEnum {
    error = "error", success = "success", none = "none"
}
